import { createSlice } from '@reduxjs/toolkit';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';


const dashboardVariant = createSlice({
    name: 'dashboardVariant',
    initialState: 0,
    reducers: {
        setDashboardVariant: (state, action) => action.payload
    }
});

export const useSetDashboardVariant = (variantID) => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(actions.setDashboardVariant(variantID));
    }, [variantID, dispatch]);
}

export const { name, actions, reducer } = dashboardVariant;